(() => {
  if (window.EyesnugCandyRackPppLoader) return;

  const containerSelector = "[data-eyesnug-deferred-candyrack-ppp]";
  const observedContainers = new Set();
  let observer;

  const isDataScript = (script) =>
    script.type === "application/json" || script.type === "application/ld+json";

  const rebuildExecutableScript = (sourceScript) => {
    const liveScript = document.createElement("script");

    Array.from(sourceScript.attributes).forEach((attribute) => {
      if (attribute.name === "type" && attribute.value === "application/x-eyesnug-deferred-module") return;
      if (attribute.name === "data-src") return;
      liveScript.setAttribute(attribute.name, attribute.value);
    });

    if (sourceScript.type === "application/x-eyesnug-deferred-module") {
      liveScript.type = "module";
      liveScript.src = sourceScript.dataset.src || "";
    } else {
      liveScript.textContent = sourceScript.textContent;
    }

    return liveScript;
  };

  const activateContainer = async (container) => {
    if (!container || container.dataset.eyesnugCandyrackPppLoaded === "true") return;

    container.dataset.eyesnugCandyrackPppLoaded = "true";
    observer?.unobserve(container);
    observedContainers.delete(container);

    const template = container.querySelector("[data-eyesnug-candyrack-template]");
    if (!template) return;

    const fragment = template.content.cloneNode(true);
    const executableScripts = [];

    fragment.querySelectorAll("script").forEach((sourceScript) => {
      if (isDataScript(sourceScript)) return;

      const marker = document.createComment("eyesnug-candyrack-script");
      executableScripts.push({ marker, sourceScript });
      sourceScript.replaceWith(marker);
    });

    container.querySelector("[data-eyesnug-candyrack-placeholder]")?.remove();
    template.remove();
    container.appendChild(fragment);

    for (const { marker, sourceScript } of executableScripts) {
      const liveScript = rebuildExecutableScript(sourceScript);
      marker.replaceWith(liveScript);

      if (liveScript.src) {
        await new Promise((resolve) => {
          const finish = () => resolve();
          liveScript.addEventListener("load", finish, { once: true });
          liveScript.addEventListener("error", finish, { once: true });
          window.setTimeout(finish, 5000);
        });
      }
    }

    container.setAttribute("aria-busy", "false");
  };

  const registerContainers = (root = document) => {
    const containers = [];

    if (root instanceof Element && root.matches(containerSelector)) {
      containers.push(root);
    }

    root.querySelectorAll?.(containerSelector).forEach((container) => {
      containers.push(container);
    });

    containers.forEach((container) => {
      if (container.dataset.eyesnugCandyrackPppLoaded === "true") return;

      ["pointerenter", "touchstart", "focusin"].forEach((eventName) => {
        container.addEventListener(eventName, () => activateContainer(container), {
          once: true,
          passive: eventName !== "focusin",
        });
      });

      if (window.Shopify?.designMode) {
        activateContainer(container);
        return;
      }

      if (!observer) {
        activateContainer(container);
        return;
      }

      observedContainers.add(container);
      observer.observe(container);
    });
  };

  if ("IntersectionObserver" in window) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) activateContainer(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "300px 0px",
        threshold: 0,
      }
    );
  }

  window.EyesnugCandyRackPppLoader = {
    activate: activateContainer,
    register: registerContainers,
  };

  registerContainers();

  document.addEventListener("shopify:section:load", (event) => {
    registerContainers(event.target);
  });
})();
